import React, { useEffect, useState, createContext } from 'react';
import { auth, provider, signInWithPopup, signOut, db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export const UserContext = createContext();

function AuthWrapper({ children }) {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);

  const login = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const userEmail = result.user.email;

      if (!userEmail.endsWith('@slateandash.com')) {
        alert('Access restricted to @slateandash.com users.');
        await signOut(auth);
      } else {
        setUser(result.user);
      }
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const logout = async () => {
    await signOut(auth);
    setUser(null);
    setRoles([]);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (u) => {
      if (u && u.email.endsWith('@slateandash.com')) {
        setUser(u);

        const ref = doc(db, 'internal-users', u.email);
        const snap = await getDoc(ref);
        
        if (snap.exists()) {
          setRoles(snap.data().roles || []);
        } else {
          // Auto-create document with default roles
          await setDoc(ref, {
            email: u.email,
            roles: []
          });          
          setRoles([]);
        }
        
      } else {
        setUser(null);
        setRoles([]);
      }
    });

    return unsubscribe;
  }, []);

  if (!user) {
    return (
      <div style={{ textAlign: 'center', marginTop: '4rem' }}>
        <h2>Welcome to the SA Dashboard</h2>
        <button onClick={login}>Sign in with Google</button>
      </div>
    );
  }

  return (
    <UserContext.Provider value={{ user, roles, logout }}>
      <div style={{ textAlign: 'right', padding: '1rem' }}>
        <span>{user.displayName} ({user.email})</span>
        <button onClick={logout} style={{ marginLeft: '1rem' }}>Log out</button>
      </div>
      {children}
    </UserContext.Provider>
  );
}

export default AuthWrapper;
